import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useAction } from 'hooks';
import Button from 'components/Form/Button';
import PencilIcon from 'svg/pencil.svg';
import * as actions from 'modules/App/actions';
import { AVATAR_CROP_MODAL } from 'modules/App/constants';
const EditBtn = ({ Icon })=>{
    const openModal = useAction(actions.openModal, AVATAR_CROP_MODAL);
    const EditIcon = Icon || PencilIcon;
    return /*#__PURE__*/ _jsx("div", {
        className: "avatar__btn",
        children: /*#__PURE__*/ _jsx(Button, {
            styleModifier: "primary",
            className: "btn--filled btn--block file__btn",
            onClick: openModal,
            children: /*#__PURE__*/ _jsx(EditIcon, {
                className: "avatar__btn__icon"
            })
        })
    });
};
export default EditBtn;
